import * as claims from "./claims";
import * as enums from "./enums";
import * as formats from "./formats";
import * as langs from "./langs";
import * as localStorage from "./local-storage";
import * as notifications from "./notifications";
import * as urls from "./urls";
import * as categories from "./categories";
import * as twilio from "./twilio";
import * as contractStatus from "./contract-status";
import * as organizationType from "./organization-type";
import * as industry from "./industry";
import * as ratingSteps from "./rating-steps";

export default {
  claims,
  enums,
  formats,
  langs,
  localStorage,
  notifications,
  urls,
  categories,
  twilio,
  contractStatus,
  organizationType,
  industry,
  ratingSteps
};
